/* eslint-disable */
import EventEmitter from "events";
import loadScript from "load-script";

const SDK_URL = "https://www.youtube.com/iframe_api";
const SDK_GLOBAL = "YT";
const SDK_GLOBAL_READY = "onYouTubeIframeAPIReady";
const MATCH_URL = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;

const loadIframeAPICallbacks = [];

export default class Youtube extends EventEmitter {
  static canPlay(url) {
    return MATCH_URL.test(url);
  }

  constructor(el) {
    super();

    const elem = typeof el === "string" ? document.querySelector(el) : el;

    if (elem.id) {
      this._id = elem.id;
    } else {
      this._id = elem.id = `ytplayer-${Math.random()
        .toString(16)
        .slice(2, 8)}`;
    }

    if (elem.attr("src") && elem.attr("src").match(MATCH_URL)[1]) {
      this.videoId = elem.attr("src").match(MATCH_URL)[1];
    }

    this.destroyed = false;

    this._api = null;
    this._player = null;

    this._ready = false; // is the player ready?

    this.iframe = el;
    this.player;
  }

  getSDK() {
    console.log("get sdk");
    if (window[SDK_GLOBAL] && window[SDK_GLOBAL].loaded) {
      return Promise.resolve(window[SDK_GLOBAL]);
    }
    return new Promise((resolve, reject) => {
      const previousOnReady = window[SDK_GLOBAL_READY];
      window[SDK_GLOBAL_READY] = function() {
        if (previousOnReady) previousOnReady();
        resolve(window[SDK_GLOBAL]);
      };
      loadScript(SDK_URL, err => {
        if (err) reject(err);
      });
    });
  }

  _createPlayer(videoId) {
    this._player = new this._api.Player("existing-iframe-example", {
      events: {
        onReady: this.onPlayerReady()
      }
    });
  }

  load() {
    if (!this._api) return console.log("no api loaded yet");

    if (!this._player) {
      this._createPlayer(this.videoId);
      return;
    }

    if (!this._ready) return;
  }

  autoplay() {
    this.iframe[0].src += "&autoplay=1&rel=0";
  }

  onPlayerReady(event) {
    this._ready = true;
    event.target.playVideo();
  }

  onError(error) {
    console.log(error);
  }
}
/* eslint-enable */
